/* eslint-disable @typescript-eslint/no-explicit-any */
import { updateProfile } from "@/api/moimAPI";
import { CHILD_GROUP_MOCK } from "@/constant/childGroupMock";
import { useCurrentUser } from "@/provider/currentUser";
import WebApp from "@twa-dev/sdk";
import React from "react";
import Dialog from "../DialogBase";
import * as Styled from "./styled";

export interface IHandler {
  onOpen(): void;
  onClose(): void;
}

const JoinTeams = React.forwardRef<IHandler>((_, ref) => {
  const { setCurrentUser, currentUser } = useCurrentUser();
  const [isUploading, setUploadStatus] = React.useState(false);
  const [selectedGroup, setSelected] = React.useState<Moim.Group.IGroup>();
  const [isOpen, setOpen] = React.useState(false);

  const userTeamId = (currentUser as any)?.primarySubGroupIds?.[0];

  const handleClose = React.useCallback(() => {
    if (isUploading) return;
    setOpen(false);
  }, [isUploading]);

  const handleSubmit = React.useCallback(() => {
    if (!selectedGroup) {
      WebApp.showAlert("팀을 선택해주세요");
      return;
    }
    setUploadStatus(true);
    updateProfile({
      signUpInfo: {
        subgroupIds: [selectedGroup.id],
      },
    })
      .then(response => {
        setCurrentUser(response);
        setOpen(false);
      })
      .finally(() => {
        setUploadStatus(false);
      });
  }, [selectedGroup, setCurrentUser]);

  React.useEffect(() => {
    if (userTeamId) {
      setSelected(CHILD_GROUP_MOCK.find(item => item.id === userTeamId));
    }
  }, [userTeamId]);

  React.useImperativeHandle(ref, () => ({
    onOpen: () => setOpen(true),
    onClose: handleClose,
  }));

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Styled.Container $uploading={isUploading}>
        <Styled.FloatHeader $show={Boolean(selectedGroup)}>
          <button onClick={handleSubmit}>
            {selectedGroup?.name} - 선택 완료 ⏎
          </button>
        </Styled.FloatHeader>

        <Styled.Welcome>
          <div className="title">가입을 환영합니다!</div>
          <div className="subTitle">⚽️본인의 홈팀을 골라주세요</div>
        </Styled.Welcome>

        <Styled.GridWrapper>
          {CHILD_GROUP_MOCK.map(item => (
            <Styled.Item
              role="button"
              key={`child_group_${item.id}`}
              $selected={item.id === selectedGroup?.id}
              onClick={() => {
                setSelected(item);
              }}
            >
              {item.icon.type === "image" ? (
                <img src={item.icon.data.url} />
              ) : (
                <div
                  className="logoBox"
                  style={{
                    backgroundColor: item.icon.data.bg_color,
                    color: item.icon.data.color,
                  }}
                >
                  {item.icon.data.text}
                </div>
              )}
              <div className="name">{item.name}</div>
            </Styled.Item>
          ))}
        </Styled.GridWrapper>
      </Styled.Container>
    </Dialog>
  );
});

export default JoinTeams;
